import { PropertyConfig, PropertyOptionsList } from "@cervval.js/common/src/forms/propertyConfig";
import { PropertyConfigType } from "@cervval.js/common/src/forms/propertyConfig.types";
import { keyof } from "@cervval.js/common/src/tools/object.tools";
import { BOOKING_MODALITY, BookingDataSourceUID } from "../data/booking.ds";
import { I18nPropertyConfig } from "./propertyConfig.i18n";

export type VisioModality = {
    _modality: BOOKING_MODALITY
}
/** Product override PC for booking session */
export function getVisioModalityPropertyConfig(): PropertyConfig<PropertyConfigType, PropertyOptionsList>[] {
    const i18n = I18nPropertyConfig().visio;
    return [
        {
            label: i18n.modality,
            propertyName: keyof<VisioModality>("_modality"),
            typeUid: PropertyConfigType.LISTSELECT,
            options: {
                itemList: BookingDataSourceUID.BOOKING_MODALITY
            }
        }
    ];
}